module.exports = __webpack_public_path__ + "media/images/business/illust-case-04-b3edab13b943814cbd4bf3aed6f6755f.svg";